class FooterUseCase {
    constructor(footerRepo) {
        this.footerRepo = footerRepo;
    }
    async getMarketStatus() {
        const footerDTOList = await this.footerRepo.getMarketStatus();
        return footerDTOList;
    }
    getFooterPdfLinks() {
        return this.footerRepo.getFooterPdfLinks();
    }
}
export default FooterUseCase;
